import { DropdownItem, TextBase, TextCaption, Tooltip } from '@carboncopyco/ui';
import { useBoolean } from 'ahooks';
import { type ReactNode, isValidElement, useRef } from 'react';

export type AssetMenuItemProps = {
  onClick: () => void;
  title: string | ReactNode;
  description: string;
  icon: ReactNode;
  permission: boolean;
  disabled?: boolean;
  tooltipText?: string;
  hoverTitle?: ReactNode;
};

export const CreateAssetMenuItem = ({
  onClick,
  icon,
  description,
  title,
  permission,
  disabled,
  tooltipText,
  hoverTitle,
}: AssetMenuItemProps) => {
  const menuItemRef = useRef<HTMLDivElement>(null);
  const [isHover, setIsHover] = useBoolean(false);

  return permission ? (
    <>
      <div
        ref={menuItemRef}
        onMouseEnter={setIsHover.setTrue}
        onMouseLeave={setIsHover.setFalse}
      >
        <DropdownItem
          onClick={onClick}
          disabled={disabled}
          asChild
        >
          <div className="flex p-4 gap-3 items-center cursor-pointer rounded-md">
            {icon}
            <div className="flex flex-col gap-0.5">
              <div className="flex items-center gap-1.5">
                {isValidElement(title) ? (
                  title
                ) : (
                  <TextBase
                    label={title}
                    color={
                      disabled ? 'text-ds-primary-300' : 'text-ds-natural-600'
                    }
                  />
                )}
                {isHover && !!hoverTitle && hoverTitle}
              </div>
              <TextCaption
                label={description}
                color={disabled ? 'text-ds-natural-200' : undefined}
              />
            </div>
          </div>
        </DropdownItem>
      </div>
      {tooltipText && (
        <Tooltip
          anchorRef={menuItemRef}
          placement="top"
          interactive={false}
          delay={[300, 0]}
        >
          <div className="p-3 w-56 ">
            <TextCaption label={tooltipText} />
          </div>
        </Tooltip>
      )}
    </>
  ) : null;
};
